import { useIsEmbedded } from '@web/intacct/build-type';
import { defaultTheme, embedTheme } from '../themes';

export const useTheme = () => {
  const isEmbedded = useIsEmbedded();
  return isEmbedded ? embedTheme : defaultTheme;
};
